require("./ynet_site_audioHeadlinesComponenta.less");
import { PageComponenta } from "widgets/commonComponents/base/pageComponenta";
import { SiteSettingsHOC, SiteSettings } from "global/components/siteSettingsHOC";
import { ComponentaInstanceProps, PageComponentaContext } from "widgets/interfaces";
import { MultiAudioAutoData } from "../../../radioWidgets/multiAudioAuto/data/multiAudioAutoData";
import { HyperLink, HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink";
import { AudioHeadlinesAutoItemSlot } from "./audioHeadlinesItemSlot";
import { multiLinkComponentaBuilder } from "widgets/commonComponents/base/multiLinkComponentaBuilder";
import { IFieldDisplayData } from "../../../../commonDataObjects/interfaces";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces";
import { isWcmEditor } from "../../../../../config/serverConfig";

interface AudioHeadlinesSiteComponentaProps{
  articles:any[]
   isMobileWeb:boolean 
    fieldsDisplaySettings:IFieldDisplayData
    numberOfVisibleItems:number
     rightTitleText:string
     rightTitleLinkUrl:string
     rightTitleLinkTarget:LinkTargetProperties
     leftTitleText:string
     leftTitleLinkUrl:string
     leftTitleLinkTarget:LinkTargetProperties
}
export class AudioHeadlinesSiteComponenta extends React.Component<AudioHeadlinesSiteComponentaProps,{}> {
 public static siteScriptName = "AudioHeadlinesSiteComponenta";
    
 componentDidMount() {
       !this.props.isMobileWeb && !isWcmEditor() &&  this.syncHeightWithAudioBodyBepo();
    }

    private syncHeightWithAudioBodyBepo = () => {
        // Use setTimeout to ensure AudioBodyBepoComponent is fully rendered
        setTimeout(() => {
            const audioBodyBepoComponent = document.getElementById('AudioBodyBepoComponent');
            const audioHeadlinesComponent = document.querySelector('.audio-headlines-auto-componenta') as HTMLElement;
            
            if (audioBodyBepoComponent && audioHeadlinesComponent) {
                const setHeight = () => {
                    const audioBodyHeight = audioBodyBepoComponent.offsetHeight;
                 
                    
                    if (audioBodyHeight > 0) {
                        audioHeadlinesComponent.style.height = `${audioBodyHeight}px`;
                       
                    }
                };
                
                // Set initial height
                setHeight();
                
                // Create a ResizeObserver to monitor height changes
                if (window.ResizeObserver) {
                    const resizeObserver = new ResizeObserver((entries) => {
                        for (let entry of entries) {
                            const newHeight = entry.contentRect.height;
                            if (newHeight > 0) {
                                audioHeadlinesComponent.style.height = `${newHeight}px`;
                            }
                        }
                    });
                    
                    resizeObserver.observe(audioBodyBepoComponent);
                    (this as any)._resizeObserver = resizeObserver;
                }
                
                // Fallback: Also listen to window resize events
                const handleResize = () => setHeight();
                window.addEventListener('resize', handleResize);
                (this as any)._resizeHandler = handleResize;
                
            } else {
                console.warn('AudioBodyBepoComponent or audio-headlines-auto-componenta not found');
                // Retry after a short delay
                setTimeout(() => this.syncHeightWithAudioBodyBepo(), 500);
            }
        }, 100);
    }
    
    componentWillUnmount() {
        // Clean up the ResizeObserver if it exists
        if ((this as any)._resizeObserver) {
            (this as any)._resizeObserver.disconnect();
        }
        
        // Clean up the resize event listener if it exists
        if ((this as any)._resizeHandler) {
            window.removeEventListener('resize', (this as any)._resizeHandler);
        }
    }



    render() {
        const { articles, isMobileWeb,  fieldsDisplaySettings, numberOfVisibleItems,  rightTitleText, rightTitleLinkUrl, rightTitleLinkTarget,
            leftTitleText, leftTitleLinkUrl, leftTitleLinkTarget } = this.props
        let visibleItems = [];
      

  

            if (articles) {
                
                for (let i = 0; i < numberOfVisibleItems; i++) {
                    if (articles[i]) {
                        visibleItems.push(
                            <AudioHeadlinesAutoItemSlot
                                key={i}
                                item={articles[i]}
                                isMobileWeb={isMobileWeb}
                                fieldsDisplaySettings={fieldsDisplaySettings}
                            />
                        )
                    }
                }
            }
        

        return (
            <div className={`audio-headlines-auto-componenta`}>
                {fieldsDisplaySettings.isTabVisible &&
                    <div className="audio-componenta-tab componentaTab">
                        <HyperLinkBuilder className="title-link right-title-link" href={rightTitleLinkUrl} linkTarget={rightTitleLinkTarget}>
                            <div className="title-text right-title-text">{rightTitleText}</div>
                        </HyperLinkBuilder>
                        {leftTitleText &&
                            <HyperLinkBuilder className="title-link" href={leftTitleLinkUrl} linkTarget={leftTitleLinkTarget}>
                                <div className="title-text left-title-text" >{leftTitleText}</div>
                            </HyperLinkBuilder>
                        }
                    </div>
                }
            
                <div className="slotList">
                    {visibleItems}
                </div>
            </div>
        )
    }
}